import router from './router'
import store from './store/vuex-shim'

export default {
  store,
  router
}
